<template>
  <div class="migration-guide">
    <button v-if="showBanner" type="button" class="migration-banner" @click="openModal">
      <span class="banner-copy">
        <strong>读者服务已升级至小程序</strong>
        <small>旧积分可迁移，签到、兑换和抽奖继续使用</small>
      </span>
      <span class="banner-action">立即前往</span>
    </button>

    <div v-if="modalVisible" class="migration-mask" role="presentation" @click.self="closeModal">
      <section class="migration-modal" role="dialog" aria-modal="true" aria-labelledby="migration-title">
        <button type="button" class="modal-close" aria-label="关闭迁移提示" @click="closeModal">×</button>
        <div class="modal-badge">服务号 → 小程序</div>
        <h2 id="migration-title">读者服务已升级至小程序</h2>
        <p class="modal-desc">
          原服务号账户资料及可迁移积分可转入小程序。迁移后可继续每日签到、积分兑换、参加活动、发送祝福语和参与抽奖。
        </p>
        <MiniProgramLauncher compact />
        <button type="button" class="tutorial-button" @click="goGuide">查看迁移教程</button>
      </section>
    </div>
  </div>
</template>

<script>
import MiniProgramLauncher from "@/components/MiniProgramLauncher";
import {
  getMigrationPhase,
  markMigrationModalShown,
  shouldShowMigrationModal,
  trackMigrationEvent,
} from "@/utils/migrationCampaign";

export default {
  name: "MigrationGuide",
  components: { MiniProgramLauncher },
  data() {
    return {
      modalVisible: false,
      campaign: getMigrationPhase(),
    };
  },
  computed: {
    showBanner() {
      return this.$route.name !== "AppShow";
    },
  },
  mounted() {
    if (this.showBanner) {
      trackMigrationEvent("banner_impression", { phase: this.campaign.phase });
    }
    const usertoken = localStorage.getItem("usertoken") || "";
    if (!usertoken) return;

    if (shouldShowMigrationModal({
      loggedIn: true,
      migrated: false,
      campaign: this.campaign,
    })) {
      this.openModal();
    }
  },
  methods: {
    openModal() {
      this.modalVisible = true;
      markMigrationModalShown();
      trackMigrationEvent("modal_impression", { phase: this.campaign.phase });
    },
    closeModal() {
      this.modalVisible = false;
      trackMigrationEvent("modal_close", { phase: this.campaign.phase });
    },
    goGuide() {
      this.closeModal();
      this.$router.push({ name: "AppShow" });
    },
  },
};
</script>

<style lang="less" scoped>
.migration-banner {
  position: fixed;
  z-index: 90;
  right: 12px;
  bottom: calc(12vh + env(safe-area-inset-bottom, 0px));
  width: auto;
  max-width: calc(100% - 24px);
  min-height: 52px;
  padding: 8px 10px 8px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: 0;
  color: #fff;
  background: linear-gradient(100deg, #b71f18, #df4437);
  text-align: left;
  border-radius: 28px;
  box-shadow: 0 4px 16px rgba(89, 22, 17, 0.2);
}

.banner-copy {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.banner-copy strong {
  font-size: 15px;
}

.banner-copy small {
  color: rgba(255, 255, 255, 0.9);
  font-size: 11px;
}

.banner-action {
  flex: none;
  padding: 7px 10px;
  border-radius: 18px;
  color: #b9231a;
  background: #fff;
  font-size: 13px;
  font-weight: 700;
}

.migration-mask {
  position: fixed;
  z-index: 10000;
  inset: 0;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(35, 25, 22, 0.56);
}

.migration-modal {
  position: relative;
  width: 100%;
  max-width: 420px;
  max-height: calc(100vh - 40px);
  padding: 30px 24px 24px;
  overflow-y: auto;
  box-sizing: border-box;
  border-radius: 24px;
  background: #fffaf7;
  box-shadow: 0 20px 60px rgba(49, 22, 16, 0.28);
}

.modal-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 40px;
  height: 40px;
  border: 0;
  color: #777;
  background: transparent;
  font-size: 28px;
}

.modal-badge {
  display: inline-flex;
  padding: 6px 12px;
  border-radius: 999px;
  color: #b9231a;
  background: #ffe7df;
  font-size: 13px;
  font-weight: 700;
}

.migration-modal h2 {
  margin: 18px 0 8px;
  color: #2b211e;
  font-size: 25px;
  line-height: 1.35;
}

.modal-desc {
  margin: 0 0 20px;
  color: #6f625e;
  font-size: 16px;
  line-height: 1.75;
}

.tutorial-button {
  width: 100%;
  min-height: 48px;
  margin-top: 14px;
  border: 1px solid #d9aaa0;
  border-radius: 24px;
  color: #a9231b;
  background: #fff;
  font-size: 16px;
  font-weight: 700;
}
</style>
